import { render, staticRenderFns } from "./SalesInvoiceDetail.vue?vue&type=template&id=741ba196&scoped=true"
import script from "./SalesInvoiceDetail.vue?vue&type=script&lang=ts"
export * from "./SalesInvoiceDetail.vue?vue&type=script&lang=ts"
import style0 from "./SalesInvoiceDetail.vue?vue&type=style&index=0&id=741ba196&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "741ba196",
  null
  
)

export default component.exports